import React, { useState, useEffect } from 'react';
import styles from './SplashScreen.module.css';

function SplashScreen({ onComplete }) {
    const [stage, setStage] = useState('drawing'); // 'drawing' -> 'fill' -> 'fadeOut'

    useEffect(() => {
        // Étape 1 : Tracé des lignes (0 à 4s)
        const fillTimer = setTimeout(() => {
            setStage('fill');
        }, 4000);

        // Étape 2 : Apparition du logo et disparition de l'écran (8.5s)
        const fadeOutTimer = setTimeout(() => {
            setStage('fadeOut');
        }, 8500);

        // Étape 3 : Fin complète de l'animation pour démonter le composant (10s)
        const completeTimer = setTimeout(() => {
            onComplete();
        }, 10000);

        return () => {
            clearTimeout(fillTimer);
            clearTimeout(fadeOutTimer);
            clearTimeout(completeTimer);
        };
    }, [onComplete]);

    return (
        <div className={`${styles.splashContainer} ${stage === 'fadeOut' ? styles.hidden : ''}`}>
            <div className={styles.animationWrapper}>

                {/* SVG Icon pour le tracé "Architecte" */}
                <div className={`${styles.svgContainer} ${stage === 'fill' || stage === 'fadeOut' ? styles.svgFadeOut : ''}`}>
                    <svg viewBox="0 0 100 100" className={styles.architectPath}>
                        {/* Ligne toit gauche */}
                        <path className={styles.linePath} d="M50 20 L20 45" />
                        {/* Ligne toit droit */}
                        <path className={styles.linePath} d="M50 20 L80 45" />
                        {/* Mur gauche */}
                        <path className={styles.linePath} d="M25 45 L25 80" />
                        {/* Mur droit */}
                        <path className={styles.linePath} d="M75 45 L75 80" />
                        {/* Sol */}
                        <path className={styles.linePath} d="M15 80 L85 80" />

                        {/* Quelques "traits de construction" architecturaux fins */}
                        <line x1="10" y1="20" x2="90" y2="20" className={styles.measureLine} />
                        <line x1="50" y1="10" x2="50" y2="90" className={styles.measureLine} />
                    </svg>
                </div>

                {/* Logo réel découpé qui s'assemble */}
                <div className={`${styles.assembledLogo} ${(stage === 'fill' || stage === 'fadeOut') ? styles.logoVisible : ''}`}>
                    {/* Image invisible pour conserver les dimensions du conteneur absolu */}
                    <img src="/images/logo.png" alt="" style={{ width: '100%', height: 'auto', opacity: 0 }} />
                    <img src="/images/logo.png" alt="" className={`${styles.logoPiece} ${styles.piece1}`} />
                    <img src="/images/logo.png" alt="" className={`${styles.logoPiece} ${styles.piece2}`} />
                    <img src="/images/logo.png" alt="" className={`${styles.logoPiece} ${styles.piece3}`} />
                    <img src="/images/logo.png" alt="" className={`${styles.logoPiece} ${styles.piece4}`} />
                    <img src="/images/logo.png" alt="" className={`${styles.logoPiece} ${styles.piece5}`} />
                </div>

                {/* Effet flash final */}
                <div className={`${styles.flash} ${stage === 'fill' ? styles.flashActive : ''}`}></div>

            </div>
        </div>
    );
}

export default SplashScreen;
